const host = "http://www.zgeo.work/portal";
const share = "http://www.zgeo.work/portal";
const local = host;
export {
  host,
  share,
  local
}



// WEBPACK FOOTER //
// ./src/vue.config.js